import { IconStyle, useSession, useTranslation, Theme, FAIcon, useNextgenRouter } from '@nextgen-web-framework/all';
import type { AppState } from '@nextgen-web-framework/core';

import { CartRoutePaths, ListResponse } from '@commerce-cart-webcomponents/sdk';
import { useSelector } from 'react-redux';
import styles from './AddProductsFromList.module.scss';

export const AddProductsFromList = () => {
  const {
    myList,
  }: {
    myList: ListResponse;
  } = useSelector((state: AppState) => state.commerceMyList);
  const { isRegistered, isMember, isABO, isAnonymous } = useSession();
  const router = useNextgenRouter();
  const t = useTranslation();
  const registeredText = isRegistered() ? t('cart.cartOverview.addFromWishlist') : '';
  const addProductsText = isABO() || isMember() ? t('cart.cartOverview.addFromList') : registeredText;
  const listRedirection =
    isABO() || isMember() ? `/${CartRoutePaths.LIST}` : `/${CartRoutePaths.LIST}/${myList?.listId}`;

  return isAnonymous() ? (
    <></>
  ) : (
    <div
      tabIndex={0}
      role="button"
      aria-label="redirect-to-wishlist"
      data-testid="redirect-to-wishlist-testid"
      onKeyDown={() => router.push(listRedirection)}
      onClick={() => router.push(listRedirection)}
      className={styles['add-product-from-list-container']}
    >
      <div className={styles['add-product-from-list-container-left-section']}>
        <FAIcon
          className={styles['add-product-from-list-container-left-section-icon']}
          iconName="heart"
          iconStyle={IconStyle.SOLID}
          theme={Theme.PURPLE}
        />
        <div className={styles['add-product-from-list-container-left-section-text']}>{addProductsText}</div>
      </div>
      <FAIcon iconName="chevron-right" theme={Theme.BLACK} />
    </div>
  );
};
